import {limitTo, rupiah} from 'utils/formatter'
import styles from './DiscountTable.css'
class DiscountTable extends React.Component {
  render () {
    let {discounts, isRefunded} = this.props
    return (<div>{discounts ? (discounts.length > 0) && <table className={`table table-responsive ${styles['discount-table']}`}>
      <tbody>
        {discounts.map((paymentDiscount, i) => (<tr key={i}>
          <td className={styles['discount-cell']}>
            <div className={styles['discount']}>
              <div className={styles['text-left']}>
                {limitTo(paymentDiscount.discount_name, 25)} { paymentDiscount.discount_name.length > 25 ? '...' : '' }
              (Rp)
            </div>

              <div className={styles['text-center']}>
              &nbsp;
              </div>

              <div className={styles['text-right']}>
                {isRefunded
                ? rupiah(Math.abs(paymentDiscount.discount_amount))
                : `(${rupiah(Math.abs(paymentDiscount.discount_amount))})`
              }
              </div>
            </div>
          </td>
        </tr>))}
      </tbody>
    </table>
    : ''}</div>)
  }
}

DiscountTable.propTypes = {
  discounts: React.PropTypes.array,
  isRefunded: React.PropTypes.bool
}

export default DiscountTable



// WEBPACK FOOTER //
// ./app/components/receipt/commons/ListItemBox/DiscountTable.js